import { showToast } from "@/components/base/Toast";

export async function shareContent(title: string, path: string) {
  const url = `${window.location.origin}${__BASE_PATH__}${path.replace(/^\//, "")}`;
  const nav = navigator as Navigator & {
    share?: (data: { title?: string; text?: string; url?: string }) => Promise<void>;
  };

  if (typeof nav.share === "function") {
    try {
      await nav.share({ title, text: title, url });
      return;
    } catch {
      /* user cancelled — fall through to copy */
    }
  }

  try {
    await navigator.clipboard.writeText(url);
    showToast("链接已复制，快分享给朋友吧", "ri-link");
  } catch {
    window.prompt("复制下面的链接分享：", url);
  }
}